export default __webpack_public_path__ + "static/media/Error404.17f47bcf.png";